import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _Activity$icons;
var _excluded = ["activity", "duration", "isOutdated", "bsSize", "onClick", "className"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var Activity = /*#__PURE__*/forwardRef(function (props, ref) {
  var activity = props.activity,
    duration = props.duration,
    isOutdated = props.isOutdated,
    bsSize = props.bsSize,
    onClick = props.onClick,
    className = props.className,
    remainingProps = _objectWithoutProperties(props, _excluded);
  if (!activity) {
    return null;
  }
  var icon = Activity.icons[activity];
  var wrapperClassNames = classNames('activity', "activity-".concat(activity), isOutdated && 'opacity-50', bsSize && "activity-".concat(bsSize), className && className);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, remainingProps, {
    className: wrapperClassNames,
    onClick: onClick
  }), /*#__PURE__*/React.createElement("span", {
    className: "activity-icon"
  }, /*#__PURE__*/React.createElement("span", {
    className: "rioglyph ".concat(icon)
  })), duration && /*#__PURE__*/React.createElement("span", {
    className: "activity-text"
  }, duration));
});
Activity.AVAILABLE = 'available';
Activity.DRIVING = 'driving';
Activity.RESTING = 'resting';
Activity.WORKING = 'working';
Activity.icons = (_Activity$icons = {}, _defineProperty(_Activity$icons, Activity.WORKING, 'rioglyph-status-working'), _defineProperty(_Activity$icons, Activity.AVAILABLE, 'rioglyph-status-available'), _defineProperty(_Activity$icons, Activity.DRIVING, 'rioglyph-status-driving'), _defineProperty(_Activity$icons, Activity.RESTING, 'rioglyph-status-resting'), _Activity$icons);
Activity.SIZE_SM = 'sm';
Activity.SIZE_LG = 'lg';
Activity.SIZE_XL = 'xl';
Activity.defaultProps = {
  className: '',
  isOutdated: false,
  onClick: function onClick() {}
};
Activity.propTypes = {
  activity: PropTypes.oneOf([Activity.AVAILABLE, Activity.DRIVING, Activity.RESTING, Activity.WORKING]).isRequired,
  bsSize: PropTypes.oneOf([Activity.SIZE_SM, Activity.SIZE_LG, Activity.SIZE_XL]),
  className: PropTypes.string,
  duration: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isOutdated: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};
export default Activity;